import {
  Button,
  H3,
  Modal,
  P,
  PropsModal,
  lightTheme,
  taxRateLabel,
} from '@vgrubs/components';
import { LocationTaxRateEntity } from 'components/src/types/taxRate.types';

export const DeleteTaxRateModal = ({
  deleteModal,
  closeModal,
  handleDelete,
}: PropsModal & {
  deleteModal: LocationTaxRateEntity | null;
  handleDelete: () => void;
}) => (
  <Modal
    isOpen={!!deleteModal}
    closeModal={closeModal}
    logo={false}
    zIndex={110}
  >
    <H3 $mb="24" $color={lightTheme.primary}>
      Are you sure
    </H3>
    <P $mb="16">
      Delete {deleteModal ? taxRateLabel(deleteModal) : 'this tax'}?
    </P>
    <P $mb="40">
      Items that were set to use only this tax fall back to the location&apos;s
      taxes the next time the menu is published.
    </P>

    <Button $selected $w="100%" $mb="8" onClick={handleDelete}>
      Confirm
    </Button>

    <Button $selected $w="100%" $gray onClick={() => closeModal?.()}>
      Cancel
    </Button>
  </Modal>
);
